const DrillStockInCategoryMap = {
  '1': '订单系统',
  '2': '其他库房',
  '3': '外来钻头',
  '4': '服务回收',
  '5': '退货入库',
}

const DrillStockOutCategoryMap = {
  '1': '调货出库',
  '2': '服务出库',
  '3': '修复出库',
  '4': '销售出库',
  '5': '损毁出库',
  '6': '报废出库',
}

const ItemStockInCategoryMap = {
  '1': '一般入库',
  '2': '特殊入库',
}

const ItemStockOutCategoryMap = {
  '1': '一般出库',
  '2': '特殊出库',
}

const DrillStageMap = {
  "1": "待发货",
  "2": "可维修",
  "3": "未使用",
  "4": "销售",
  "5": "损毁",
  "6": "报废",
  "7": "已发货"
}

const DrillTypeMap = {
  '2': "PDC钻头",
  '3': "复合钻头",
  '4': "矿用钻头"
}

const DrillIsNewMap = {
  1: "新",
  2: "旧",
  3: "返新",
  4: "修复"
}

const BlockTypeMap = {
  1: "东北大区",
  2: "陕北大区",
  3: "西北大区",
  4: "西南大区",
  5: "海纳",
  6: "中部大区",
}

const DrillPackageType = {
  '1': "奥瑞拓",
  '2': "海纳",
  '3': "达坦",
  '4': "鼎鑫",
  '5': "其他",
}

const ReportUserLevelMap = {
  '1': '服务人员',
  '2': '大区',
  '3': '总部',
}

const ReportDrillStatusMap = {
  '1': '下钻',
  '2': '钻进',
  '3': '其他',
  '4': '起钻',
}

const ProjectDrillStatusMap = {
  1: '待钻',
  2: '在钻',
  3: '完钻'
}

const PurchaseOrderStatusMap = {
  1: '待质检',
  2: '待入库',
  3: '待结算',
  100: '已完成',
}

const PurchaseOrderLogMap = {
  1: '创建采购单',
  2: '完成到货质检',
  3: '完成入库',
  4: '完成发票结算',
}
const SaleOrderStatusMap = {
  1: '待发货',
  2: '待开票',
  100: '已完成',
}

const OutboundOrderStatusMap = {
  1: '待出库',
  2: '已出库',
}

const CommodityCategoryMap = [
  { id: 2, name: '复合片' },
  { id: 1, name: '钻头体' },
  { id: 3, name: '焊料' },
  { id: 4, name: '接头' },
  { id: 5, name: '硬质合金' },
  { id: 6, name: '喷嘴' },
  { id: 7, name: '牙轮' },
  { id: 8, name: '耗材' },
  { id: 9, name: '包装箱' },
  { id: 10, name: '卸扣器' },
  { id: 11, name: '气体' },
]

export {
  DrillStockInCategoryMap,
  DrillStageMap,
  DrillStockOutCategoryMap,
  DrillTypeMap,
  DrillIsNewMap,
  BlockTypeMap,
  DrillPackageType,
  ItemStockInCategoryMap,
  ItemStockOutCategoryMap,
  ReportUserLevelMap,
  ReportDrillStatusMap,
  ProjectDrillStatusMap,
  PurchaseOrderStatusMap,
  PurchaseOrderLogMap,
  SaleOrderStatusMap,
  CommodityCategoryMap,
  OutboundOrderStatusMap
}
